/* eslint-disable */
export default {
  noRecords: 'Keine aktuellen Einträge gefunden.',
  inBound: 'Eingehend',
  outBound: 'Ausgehend',
  missed: 'Verpasster Anruf',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
